/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthorizationLeadScreenerLeadInfoState
 */
export interface PalAuthorizationLeadScreenerLeadInfoState {
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfoState
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfoState
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfoState
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthorizationLeadScreenerLeadInfoState
     */
    country_id?: string;
}

/**
 * Check if a given object implements the PalAuthorizationLeadScreenerLeadInfoState interface.
 */
export function instanceOfPalAuthorizationLeadScreenerLeadInfoState(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PalAuthorizationLeadScreenerLeadInfoStateFromJSON(json: any): PalAuthorizationLeadScreenerLeadInfoState {
    return PalAuthorizationLeadScreenerLeadInfoStateFromJSONTyped(json, false);
}

export function PalAuthorizationLeadScreenerLeadInfoStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthorizationLeadScreenerLeadInfoState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'country_id': !exists(json, 'country_id') ? undefined : json['country_id'],
    };
}

export function PalAuthorizationLeadScreenerLeadInfoStateToJSON(value?: PalAuthorizationLeadScreenerLeadInfoState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'country_id': value.country_id,
    };
}

